interface IIdentifiable {
  id: string
}

interface IMapPinSelectionParams {
  shouldRenderSwipeableCards: boolean
  swipeableItemId: string
  swipeableEntities: IIdentifiable[]
  selectedEntities: IIdentifiable[]
  displayedEntityId?: string
  storeEntities?: IIdentifiable[]
}

export function isMapPinSelected({
  shouldRenderSwipeableCards,
  swipeableItemId,
  swipeableEntities,
  selectedEntities,
  displayedEntityId,
  storeEntities = swipeableEntities,
}: IMapPinSelectionParams): boolean {
  if (shouldRenderSwipeableCards) {
    return swipeableEntities.some(({ id }) => id === swipeableItemId)
  }

  return storeEntities.some(
    ({ id }) =>
      selectedEntities.some(entity => entity.id === id) ||
      displayedEntityId === id,
  )
}
